import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ContractService } from '../contract.service';
import { concat } from 'rxjs/observable/concat';
import { CustomerSummaryService } from '../../customer';
import { IsActive, IsCompleted } from '../../../../model';
import { ExceptionHelper } from '../../../../helper';
import { JobSummaryService } from '../../job/job-summary';
import { last, catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { OWL_datetime_formats } from '../../owl_datetime_formats';

@Component({
  selector: 'app-contract-add',
  templateUrl: './contract-add.component.html',
  styleUrls: ['./contract-add.component.css'],
  providers: [
    { provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats },
  ],
})

export class ContractAddComponent implements OnInit {
  @ViewChild('successModal') successModal: any;
  contractForm: FormGroup;
  customerArr = [];
  jobArr = [];
  dropdownSettingsCustomer = {
    singleSelection: true,
    text: 'Select Customer',
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    labelKey: 'shortName'
  };
  dropdownSettingsJob = {
    singleSelection: true,
    text: 'Select Job',
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    labelKey: 'jobNumber'
  };
  constructor(
    private chRef: ChangeDetectorRef,
    private contractService: ContractService,
    private customerSummaryService: CustomerSummaryService,
    private exception: ExceptionHelper,
    private fb: FormBuilder,
    private router: Router,
    private jobSummaryService: JobSummaryService,

  ) {
    this.contractForm = this.fb.group({
      customerId: ['', [Validators.required]],
      signingDate: ['', [Validators.required]],
      description: ['', [Validators.required]],
      contract: [[], [Validators.required]],
      jobId: [[], [Validators.required]],
    });

   }

  ngOnInit() {
    $('div.c-btn').attr('id', 'single-select');
    this.getCustomerList();
    this.contractForm.get('customerId').valueChanges.subscribe(res => {
      this.getJobList(res[0].id);
    });
  }
  closeSuccessModel() {
    this.router.navigate(['/home/contract/summary']);
  }
  createServiceContract(customerId, jobId, contractInfo): Observable<any> {
    return this.contractService.createServiceContract(customerId, jobId, contractInfo);
  }
  getCustomerList() {
    this.customerSummaryService.getSummary(IsActive.active).subscribe(res => {
      this.customerArr = res.customerListModel;

    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
    }, () => {
      this.chRef.detectChanges();
    });
  }
  getJobList(customerId) {
    this.contractForm.get('jobId').setValue([]);
    this.jobSummaryService.getSummary(null, null, IsCompleted.both, null, false, customerId).subscribe(res => {
      this.jobArr = res.jobListModel;
    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
    }, () => {
      this.chRef.detectChanges();
    });
  }
  submitContractForm(form) {

    const {description} = form.value;
    const signingDate = moment(form.value.signingDate).format('YYYY-MM-DD');
    const customerId = form.value.customerId[0].id;
    const jobId = form.value.jobId[0].id;
    const contract = form.value.contract;
    concat(
      this.createServiceContract(customerId, jobId, {description, signingDate}),
      this.uploadContractPDF(customerId, jobId, contract)
    ).pipe(
      catchError(error => {
        return Observable.throw(error);
      }),
      last()
    ).subscribe(res => {
      this.successModal.show();
    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
    });
  }

  onCloseCustomer(items: any) {
    if (this.contractForm.get('customerId').value.length === 0) {
      this.contractForm.controls['customerId'].setErrors({'required': true});
    }
  }
  onCloseJob(items: any) {
    if (this.contractForm.get('jobId').value.length === 0) {
      this.contractForm.controls['jobId'].setErrors({'required': true});
    }
  }
  onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      this.contractForm.get('contract').setValue(event.target.files);
    }
  }

  uploadContractPDF(customerId, jobId, contractFile): Observable<any> {
    return Observable.create(observer => {
      if (contractFile) {

        const [file] = contractFile;

        const fileData = new FormData();
        fileData.append('contract', file);
        this.contractService.uploadContractPDF(customerId, jobId, fileData)
          .subscribe(res => {
            observer.next(res);
            observer.complete();
          }, error => {
            observer.error(error);
          });
      } else {
        observer.next(null);
        observer.complete();
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/contract/contract-add/contract-add.component.ts